var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CompanyList.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-15f66886\",\"hasScoped\":false,\"transformToRequire\":{\"img\":[\"src\",\"srcset\"]}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CompanyList.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/index/modules/CompanyList.vue
// module id = f0i3
// module chunks = 1